// ImpuestosTabXL - Sprint 44 Fase 3 Vista 2.
// IVA global del cliente. Check XL + input numerico con sugerencia por pais.
// Si el cliente no aplica impuesto, el campo tasa_impuesto queda oculto.
import { useEffect } from 'react';
import { ensureKeyframes, injectCSS } from '../../../design/motion';
import XLInput from '../../../components/xl/XLInput';
import XLCheck from '../../../components/xl/XLCheck';
import { ivaDefault } from '../../clientes/form/utils';

const CSS_ID = 'xl-cli-imp-css';
const CSS = `
.xl-cli-imp {
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 560px;
}
.xl-cli-imp__hint {
  background: rgba(37,99,235,0.08);
  border: 1px solid rgba(37,99,235,0.22);
  color: var(--xl-color-info);
  border-radius: var(--xl-radius-md);
  padding: 10px 12px;
  font-size: 13px;
  line-height: 1.45;
  font-family: var(--xl-font-sans);
}
[data-xl-theme="dark"] .xl-cli-imp__hint {
  background: rgba(96,165,250,0.14);
  border-color: rgba(96,165,250,0.32);
}
`;

export default function ImpuestosTabXL({ form, set }) {
  useEffect(() => {
    ensureKeyframes();
    injectCSS(CSS_ID, CSS);
  }, []);

  const sugerido = ivaDefault(form.pais);
  const hint = sugerido
    ? ('Por defecto en ' + (form.pais || 'este pais') + ': ' + sugerido + '%')
    : undefined;

  return (
    <div className="xl-cli-imp">
      <div className="xl-cli-imp__hint" role="note">
        IVA global editable. Por defecto se ajusta al pais del cliente.
        Si el cliente no tiene impuestos aplicables, desmarca la casilla.
      </div>

      <XLCheck
        checked={!!form.aplicar_impuesto}
        onChange={(v) => set('aplicar_impuesto', v)}
        label="Aplicar impuesto al cliente"
      />

      {form.aplicar_impuesto && (
        <XLInput
          label="Tasa de impuesto (%)"
          type="number"
          step="0.01"
          value={form.tasa_impuesto === null || form.tasa_impuesto === undefined ? '' : form.tasa_impuesto}
          onChange={(e) => {
            const v = e.target.value;
            set('tasa_impuesto', v === '' ? null : Number(v));
          }}
          placeholder="19"
          hint={hint}
        />
      )}
    </div>
  );
}
